<div class="full-width">
    <highcharts-chart 
      [style.visibility]="hasData===false? 'hidden': 'visible'"
      *ngIf="isHighcharts"
      [Highcharts]="Highcharts"
      [constructorType]="chartConstructor"
      [options]="chartOptions"
      [callbackFunction]="chartCallback"
      [(update)]="updateFlag"
      [oneToOne]="true"
      style="padding-top: 10px; margin-top: 10px; width: 100%; height: 300px; display: block; width:auto"
      class="align-center"
      >
    </highcharts-chart>
  </div>